import { render } from "./TransactionTaggingModal.vue?vue&type=template&id=a2b633ae&scoped=true"
import script from "./TransactionTaggingModal.vue?vue&type=script&lang=js"
export * from "./TransactionTaggingModal.vue?vue&type=script&lang=js"

import "./TransactionTaggingModal.vue?vue&type=style&index=0&id=a2b633ae&scoped=true&lang=css"
import "./TransactionTaggingModal.vue?vue&type=style&index=1&id=a2b633ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b633ae"]])

export default __exports__